import * as React from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from "../../../store/";
import { Outlet } from "react-router-dom";
import { Box, Container, CssBaseline } from "@mui/material";
import WebQuestions from "../../pages/WebQuestions";
import qs from "qs";

export default function QuestionLayout() {
	const { quizId } = qs.parse(window.location.search, {
		ignoreQueryPrefix: true,
	});
	
    const location = useLocation();
    const navigate = useNavigate();
	const learner = useSelector((state) => state.learner || {});
    const publicUrl = process.env.PUBLIC_URL;
	const [testLevel, setTestLevel] = React.useState(quizId);

	React.useEffect(() => {
        if ((learner?.details?.complete === true || !location?.search) && location.pathname !== `${publicUrl}/complete`) {
            navigate(`${publicUrl}/complete${location?.search || ''}`);
        }

		if (typeof learner?.details?.testLevel !== "undefined") {
			setTestLevel(learner?.details?.testLevel);
		}
    }, [learner, location, navigate, publicUrl]);
	return (
		<React.Fragment>
			{["acsf3", "acsf3shortcourse"].indexOf(testLevel) !== -1 ?
				<React.Fragment>
					<CssBaseline />
					<Container
						maxWidth="sm"
						sx={{
							bgcolor: "#016d7c",
							height: "100%",
							display: "flex",
							flexDirection: "column",
							p: { xs: 0, sm: "2px" },
							pl: { xs: 0, sm: "6px" },
							position: "relative",
						}}
					>
						<Outlet />
					</Container>
				</React.Fragment>
			: 
				<Box sx={{
					position: "relative",
					width: "100%",
					height: "100%",
					fontFamily: "'Arimo', sans-serif",
					overflowY: "hidden",
					"@media (max-width: 1024px), (max-height: 768px)": {
						transform: "scale(0.8)",
						transformOrigin: "left top",
						width: "125%",
						height: "125%",
						overflowY: "hidden",
					},
					"@media (max-width: 800px), (max-height: 600px)": {
						transform: "scale(0.7)",
						transformOrigin: "left top",
						width: "142.85%",
						height: "142.85%",
						overflowY: "hidden",
					},
				}}
				>
				<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							width: "100%",
							height: "100%"
						}}
					>
						
						<CssBaseline />
						<WebQuestions />
					</Box>
				</Box>
			}
		</React.Fragment>
	);
}
